import {
  AUC_UNIT_OPTIONS,
  CONCENTRATION_UNIT_OPTIONS,
} from './quantityUnits';

export interface TargetUnitOption {
  value: string;
  label: string;
}

const FIXED_TARGET_UNITS: Record<string, string> = {
  'AUC/MIC': 'h',
  'Cmax/MIC': 'ratio',
  '%fT>MIC': '%',
};

export const getFixedPkpdTargetUnit = (method: unknown): string | undefined => (
  FIXED_TARGET_UNITS[String(method || '').trim()]
);

export const normalizePkpdTargetUnit = (method: unknown, unit: unknown): string => (
  getFixedPkpdTargetUnit(method) || String(unit || '').trim()
);

export const getPkpdTargetUnitOptions = (method: unknown): TargetUnitOption[] => {
  const normalizedMethod = String(method || '').trim();
  if (normalizedMethod === 'Target AUC') return AUC_UNIT_OPTIONS;
  if (normalizedMethod === 'Target Concentration' || normalizedMethod === 'Target Cmax') {
    return CONCENTRATION_UNIT_OPTIONS;
  }
  if (normalizedMethod === 'AUC/MIC') {
    return [{ value: 'h', label: 'h（AUC/MIC 的量纲）' }];
  }
  if (normalizedMethod === 'Cmax/MIC') {
    return [{ value: 'ratio', label: 'ratio（无量纲比值）' }];
  }
  if (normalizedMethod === '%fT>MIC') {
    return [{ value: '%', label: '%（时间百分比）' }];
  }
  return [];
};

export const getPkpdTargetUnitHelp = (method: unknown): string => {
  const normalizedMethod = String(method || '').trim();
  if (normalizedMethod === 'AUC/MIC') {
    return 'AUC/MIC = (mg·h/L) ÷ (mg/L)，质量与体积单位相消，因此量纲为 h。';
  }
  if (normalizedMethod === 'Cmax/MIC') {
    return 'Cmax 与 MIC 均为浓度，两者相除后为无量纲比值。';
  }
  if (normalizedMethod === '%fT>MIC') {
    return '该指标表示给药间隔内游离浓度高于 MIC 的时间百分比。';
  }
  return '单位选项已按当前计算方法的量纲限制。';
};
